var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.operatePictures)?_c('div',{staticClass:"banner"},[_c('img',{staticClass:"banner-img",attrs:{"src":_vm.data.operatePictures,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }